import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { GetOtherCandidaciesResponse, HttpResponse } from "@/types";

// Other candidacies are keyed on the talent id — guac has no pending-talent
// lookup, so a candidate without one has nothing to return and the query stays
// disabled rather than failing the request.
export function useGetOtherCandidacies({
  candidacyId,
  enabled = true,
  talentId,
}: {
  candidacyId?: string | null;
  enabled?: boolean;
  talentId?: number | null;
}) {
  return useQuery({
    enabled: enabled && !!talentId,
    queryKey: ["other-candidacies", candidacyId, talentId],
    queryFn: async () => {
      const queryParams = new URLSearchParams();

      if (candidacyId) {
        queryParams.append("candidacyId", candidacyId);
      }

      if (talentId) {
        queryParams.append("talentId", talentId.toString());
      }

      const path = `other-candidacies?${queryParams.toString()}`;
      const res = await guacHttpClient.get<
        GetOtherCandidaciesResponse[],
        HttpResponse<GetOtherCandidaciesResponse[]>
      >(path);
      return res.data;
    },
  });
}
